import { Fragment, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Preview } from 'basic-components/icons';
import Query from 'dashboard-services/api/Query';

import { commonDatalakeActions } from 'actions/modules/datalake';
import getApiConfig from 'api/ApiConfig';
import { filesDatalakeQueries } from 'queries/modules/datalake';

const PreviewAttributeAction = ({ file = undefined }) => {
  const dispatch = useDispatch(),
        [searchParams] = useSearchParams(),
        provider = useMemo(() => searchParams.get("provider") || undefined, [searchParams]),
        getQueryBuilder = useCallback(() => new Query.Builder(dispatch(getApiConfig())).withHeader("Target", provider, true), [dispatch, provider]),
        { searchFilesCall, getFileSizeCall } = filesDatalakeQueries.useOpenEditorBasedOnFile({ 
          getQueryBuilder,
          file
        }),
        onClick = useCallback(() => dispatch(commonDatalakeActions.openEditorBasedOnFile(file, { searchFilesCall, getFileSizeCall, provider })), [dispatch, file, getFileSizeCall, searchFilesCall, provider])

  if(!file) {
    return <Fragment/>
  }
  return (
    <div
        className="insight-node-widget__param__content__action__wrapper"
        onClick={onClick}
    >
      <Preview
          color="blue-bright"
          height={12}
          width={12}
      />
    </div>
  )
}

PreviewAttributeAction.propTypes = {
  file: PropTypes.object
}

export default PreviewAttributeAction;